import _ from 'lodash';
import React from 'react';
import {imageUrl} from '../../utilities/requests';


const WrappingInvoice = ({school, examinations, onLoad}) => <span>
    <div
        style={{
            float: 'right',
            margin: '.5cm',
            width: '13.8cm',
            height: '19.9cm',
            border: '1px solid black',
            boxSizing: 'border-box',
            pageBreakAfter: 'always',
        }}>
        <div style={{float: 'left', margin: '.5cm'}}>
            <img
                src="image/logo2.png"
                height="80"
                type="contain"
                onLoad={onLoad}
            />
        </div>
        <div style={{marginTop: '1.5cm', marginRight: '1cm', marginLeft: '1cm'}}>
            <br/>
            <div style={{fontSize: '20pt'}}>
                استان: <b>{school.city.region_display}</b>
            </div>
            <div style={{fontSize: '20pt'}}>
                شهر: <b>{school.city.name}</b>
            </div>
            <div style={{fontSize: '20pt'}}>
                مدرسه: <b>{school.name}</b>
            </div>
            <br/>
            <table
                style={{
                    borderCollapse: 'collapse',
                    border: '1px solid black',
                    fontSize: '14pt',
                }}>
                <thead>
                    <tr>
                        <th style={{border: '1px solid black', padding: '.25cm', width: '6cm'}}>آزمون</th>
                        <th style={{border: '1px solid black', padding: '.25cm'}}>پایه</th>
                    </tr>
                </thead>
                <tbody>
                    {_.map(examinations, (examination, index) => <tr key={index}>
                        <td style={{border: '1px solid black', padding: '.25cm'}}>{examination.title}</td>
                        <td style={{border: '1px solid black', padding: '.25cm'}}>{_.map(examination.grades, 'title').join(window.gettext(',') + ' ')}</td>
                    </tr>)}
                </tbody>
            </table>
            <br/>
            <div style={{fontSize: '20pt'}}>
                کد بسته: <b>{school.id.persian()}</b>
            </div>
        </div>
    </div>
</span>;

export default WrappingInvoice;
